export function numberWithCommas(x: number, dp: number = 2) {
  return Number(x).toLocaleString("en-US", {
    minimumFractionDigits: dp,
  });
}
